// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Accordion = t.struct({
    accordionId: t.String,
    isExpanded: t.Bool
}, 'Accordion');

export const getDefaultState = (accordionId = '') => new Accordion({
    accordionId,
    isExpanded: false
});

export default Accordion;



// WEBPACK FOOTER //
// ./src/shared/components/smart-accordion/state/accordion.js